import { useEffect } from 'react';

import { IClinic } from '../../hooks/useClinics';
import { useLocatorStore } from '../../store/useLocatorStore';

export function useAddClinicsToLocalStorage() {
  const { activeClinic } = useLocatorStore((state) => state);

  useEffect(() => {
    if (!activeClinic) return;

    // Load existing viewedClinics from localStorage
    let viewedClinics: IClinic[] = JSON.parse(localStorage.getItem('viewed-clinics') || '[]');

    // Remove the active clinic from the viewedClinics list if it already exists
    viewedClinics = viewedClinics.filter((clinic) => clinic.API_Id__c !== activeClinic.API_Id__c);

    // Add the active clinic to the viewedClinics list
    viewedClinics.push(activeClinic);

    // Keep only the 2 latest active clinics
    viewedClinics = viewedClinics.slice(-2);

    // Save the updated viewedClinics to localStorage
    localStorage.setItem('viewed-clinics', JSON.stringify(viewedClinics));
  }, [activeClinic]);
}
